import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {BarChart, ChartsLabelMark, useAnimate} from '@mui/x-charts';
import {XYVO} from "@/service/analyze";
import {OptionType} from "@/model/global";
import {useMemo} from "react";
import isEmpty from "lodash/isEmpty";
import {interpolateObject} from '@mui/x-charts-vendor/d3-interpolate';
import {styled} from "@mui/material/styles";
import {BarLabelProps} from "@mui/x-charts/BarChart/BarLabel/BarLabel";

export interface WriterCategoryRankingProps {
    option: OptionType
    top5CopyrightWriter: XYVO[]
    top5PatentWriter: XYVO[]
    top5ProjectWriter: XYVO[]
    top5TrademarkWriter: XYVO[]
    loading: boolean
}

function BarLabel(props: any) {
    const {
        color,
        yOrigin,
        x,
        y,
        width,
        skipAnimation,
        ...otherProps
    } = props;

    const Text = styled('text')(({theme}) => ({
        ...theme?.typography?.body2,
        stroke: 'none',
        fill: (theme.vars || theme)?.palette?.text?.primary,
        transition: 'opacity 0.2s ease-in, fill 0.2s ease-in',
        textAnchor: 'middle',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        dominantBaseline: 'central',
        pointerEvents: 'none',
    }));

    const animatedProps = useAnimate(
        {x: x + width / 2, y: y + 12},
        {
            initialProps: {x: x + width / 2, y: yOrigin},
            createInterpolator: interpolateObject,
            transformProps: (p) => p,
            applyProps: (element, p) => {
                element.setAttribute('x', p.x.toString());
                element.setAttribute('y', p.y.toString());
            },
            skip: skipAnimation,
        },
    );

    return (
        <Text  {...otherProps} fill={color} textAnchor="middle" {...animatedProps} />
    )
}

export default function WriterCategoryRanking({
                                                  loading,
                                                  top5CopyrightWriter, top5ProjectWriter,
                                                  option, top5TrademarkWriter, top5PatentWriter
                                              }: WriterCategoryRankingProps) {

    const top5Writer = useMemo(() => {
        let top5Writer: XYVO[] = []
        switch (option.value) {
            case 1:
                top5Writer = top5ProjectWriter;
                break
            case 2:
                top5Writer = top5PatentWriter;
                break
            case 3:
                top5Writer = top5TrademarkWriter;
                break
            case 4:
                top5Writer = top5CopyrightWriter
                break
        }
        return top5Writer
    }, [top5CopyrightWriter, top5ProjectWriter, top5TrademarkWriter, top5PatentWriter, option]);
    console.log(top5Writer, 'lllllllllll')
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack direction={'row'} spacing={2} mb={1} justifyContent={'space-between'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        撰写分类排行
                    </Typography>
                    <Stack alignItems={'start'} direction={'row'} spacing={1}>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'#FFC6C6'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>{option.label}分类</Typography>
                        </Stack>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'#7AE2CF'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>撰稿人</Typography>
                        </Stack>
                    </Stack>
                </Stack>
                <BarChart
                    height={220}
                    loading={loading}
                    localeText={{loading: "加载中", noData: "暂无数据"}}
                    margin={{left: 0, right: 0, top: 10, bottom: 0}}
                    series={[
                        {
                            data: top5Writer?.map(item => -item.y2),
                            label: '分类数量',
                            type: 'bar',
                            id: "aa",
                            color: '#FFC6C6',
                            labelMarkType: 'square',
                            valueFormatter: (d) => `${Math.abs(d || 0)}`,
                            stack: 'stack',
                        },
                        {
                            id: 'bb',
                            data: top5Writer?.map(item => item.y1),
                            label: '撰写数量',
                            type: 'bar',
                            color: '#7AE2CF',
                            stack: 'stack',
                        },
                    ]}
                    hideLegend={true}
                    slotProps={{bar: {rx: 4, ry: 4,}}}
                    xAxis={[
                        {
                            disableLine: true,
                            disableTicks: true,
                            tickNumber: 10,
                            valueFormatter: (d: number) => Math.abs(d).toString(),

                        },
                    ]}
                    disableAxisListener={true}
                    yAxis={[
                        {
                            data: top5Writer?.map((item, index) => `${item.x2}:${item.x1}`) || [],
                            width: 0,
                            disableLine: true,
                            disableTicks: true,
                            tickLabelInterval: (value: number | null, index: number) => index % 4 == 0
                        },
                    ]}
                    slots={{barLabel: BarLabel}}
                    // barLabel={(item) => {
                    //     const data: XYVO = top5Writer[item.dataIndex]
                    //     if (!isEmpty(data)) {
                    //         if (item.seriesId == "aa") {
                    //             return `${data['y2']}个`
                    //         } else if (item.seriesId == "bb") {
                    //             return `${data['y1']}个`
                    //         }
                    //     }
                    //     return "";
                    // }}
                    // yAxis={[{disableTicks: true}, {disableTicks: true}]}
                    layout="horizontal"
                />

                {/*<Grid container justifyContent={'space-between'} spacing={3}>*/}
                {/*    <Grid size={5}>*/}
                {/*        <PieChart*/}
                {/*            margin={{left: 0, right: 0, top: 10, bottom: 0}}*/}
                {/*            series={[*/}
                {/*                {*/}
                {/*                    innerRadius: 80,*/}
                {/*                    outerRadius: 95,*/}
                {/*                    id: 'platform-series',*/}
                {/*                    data: [*/}
                {/*                        {*/}
                {/*                            label: 'Mobile',*/}
                {/*                            value: 59.12,*/}
                {/*                        },*/}
                {/*                        {*/}
                {/*                            label: 'Desktop',*/}
                {/*                            value: 40.88,*/}
                {/*                        },*/}
                {/*                    ],*/}
                {/*                },*/}
                {/*                {*/}
                {/*                    innerRadius: 105,*/}
                {/*                    outerRadius: 120,*/}
                {/*                    id: 'OS-series',*/}
                {/*                    data: [*/}
                {/*                        {*/}
                {/*                            label: 'Android',*/}
                {/*                            value: 70.48,*/}
                {/*                        },*/}
                {/*                        {*/}
                {/*                            label: 'iOS',*/}
                {/*                            value: 28.8,*/}
                {/*                        },*/}
                {/*                        {*/}
                {/*                            label: 'Other',*/}
                {/*                            value: 0.71,*/}
                {/*                        },*/}
                {/*                    ],*/}
                {/*                },*/}
                {/*            ]}*/}
                {/*            width={300}*/}
                {/*            height={180}*/}
                {/*            hideLegend*/}
                {/*        />*/}
                {/*    </Grid>*/}
                {/*    <Grid size={7}>*/}
                {/*        <BarChart*/}
                {/*            layout={'horizontal'}*/}
                {/*            hideLegend={true}*/}
                {/*            margin={{left: 0, right: 0, top: 10, bottom: 0}}*/}
                {/*            series={[*/}
                {/*                {data: [4, 2, 5, 4, 1], stack: 'A', label: 'Series A1'},*/}
                {/*            ]}*/}
                {/*            height={180}*/}
                {/*            yAxis={[{data: ["周星星", "周伯通", "周树人", "周庄", "周公"], categoryGapRatio: 0.6, disableLine: true, disableTicks: true}]}*/}
                {/*            xAxis={[{disableLine: true, disableTicks: true, position: 'bottom',}]}*/}
                {/*            barLabel={(item, context) => {*/}
                {/*                console.log(item, 'kkkkkkkkkkkk')*/}
                {/*                return context.bar.height < 60 ? "高新技术企业" : item.value?.toString();*/}
                {/*            }}*/}
                {/*        />*/}
                {/*    </Grid>*/}

                {/*</Grid>*/}
            </CardContent>
        </Card>
    );
}
